export default "__VITE_ASSET__BbYcw_5j__"